






















// First try at a vue-class-component in typescript
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import Firebase from '@/horizon-firebase'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import {User} from '@/store/models'
import AuthUI = firebaseui.auth.AuthUI
import {userStore} from '@/store'

@Component({})
export default class Login extends Vue {
  // any data members become data
  // getters become computed props
  // other members become methods
  // props use special @prop() decorator or arg to @Component() decorator

  // things declared in the Component decorator have to be declared here
  // for type inference

  authUI!: AuthUI | null

  get appName() {
    return Vue.$appName
  }

  signInSuccessWithAuthResult(authResult: Firebase.auth.UserCredential, redirectUrl: string) {
    console.log('Auth: signInSuccess, result: ', {authResult, redirectUrl})
    // User successfully signed in.
    // Return type determines whether we continue the redirect automatically
    // or whether we leave that to developer to handle.
    return true
  }

  firebaseAuthUIConfig = {
    // autoUpgradeAnonymousUsers: true,
    callbacks: {
      signInSuccessWithAuthResult: this.signInSuccessWithAuthResult,
      uiShown() {
        // The widget is rendered.
        // Hide the loader.
        const loader = document.getElementById('loader')
        if (loader)
          loader.style.display = 'none'
      }
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: 'popup',
    signInSuccessUrl: '/shot', // not used?
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
      Firebase.auth.EmailAuthProvider.PROVIDER_ID,
      /*
      {
        provider: Firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        recaptchaParameters: {
          size: 'invisible'
        }
      },
      */
      // Guest/anonymous login: turned off for now
      // firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
    ],
    // Required to enable one-tap sign-up credential helper.
    credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
    // Terms of service url.
    tosUrl: '/about/terms-of-service',
    // Privacy policy url.
    privacyPolicyUrl: '/about/privacy-policy'
  }

  startAuthUI() {
    // When the user is logged in, save user data in the vuex store
    if (this.authUI)
      this.authUI.start('#firebaseui-auth-container', this.firebaseAuthUIConfig)
  }

  get nextRoute(): string {
    return this.$route.params.redirectTo ? `/${this.$route.params.redirectTo}` : 'shot'
  }

  get user(): User | null {
    return userStore?.user || null
  }

  init() {
    if (userStore?.user)
      this.$router.replace(this.nextRoute)
    else
      this.startAuthUI()
  }

  mounted() {
    this.init()
  }

  created() {
    const authUI = firebaseui.auth.AuthUI.getInstance()
    if (!authUI)
      this.authUI = new firebaseui.auth.AuthUI(Firebase.auth())
  }

  beforeDestroy() {
    this.authUI?.delete()
    this.authUI?.reset()
  }

  activated() {
    this.init()
  }
}
